import { motion } from "framer-motion";
import { ShieldCheck, Timer, RefreshCw, Lock } from "lucide-react";

const BADGES = [
  { icon: Timer, label: "Setup in 7 days" },
  { icon: ShieldCheck, label: "No long contracts" },
  { icon: RefreshCw, label: "30-day money-back" },
  { icon: Lock, label: "Your data stays yours" },
];

export default function TrustBadges() {
  return (
    <section className="relative py-8 border-y border-white/5 bg-black/40" data-testid="trust-badges">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6"
        >
          {BADGES.map((b, i) => (
            <div
              key={b.label}
              className="flex items-center gap-3 justify-center md:justify-start"
              data-testid={`trust-badge-${i}`}
            >
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-white/[0.04] border border-white/10">
                <b.icon size={16} className="text-[#00F0FF]" />
              </span>
              <span className="text-sm text-white/70">{b.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
